import { makeStyles, Theme } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) => ({
  select: {
    width: '150px',
  },
}));

export default useStyles;
